/**
 * Picking up a conversation from a file just opened or imported (trace-viewer
 * CONTENT_MODEL_SPEC §2.10). Here rather than in editor-content.ts, which the
 * CMS writers import and so must not reach the agent.
 */

import type { TraceScene } from 'trace-viewer/scene';
import { agentService } from './AgentService';
import { adoptEditorBundle } from '../editor-content';
import { BUNDLE_EXTENSION } from '../scene-formats';

/**
 * After a file was opened or imported: mount its editor folder, and pick up
 * its conversation in the chat. An import into a scene whose own conversation
 * (recorded under its document root) is under way keeps that one; the
 * imported conversations still join the editor root.
 */
export async function restoreEditorContent(
    scene: TraceScene | null | undefined,
    file: Blob & { name: string },
    replacesScene: boolean,
): Promise<void> {
    if (!scene || !file.name.toLowerCase().endsWith(BUNDLE_EXTENSION)) return;
    try {
        const session = await adoptEditorBundle(scene, file);
        if (session && (replacesScene || !agentService.session.isUnderWay(scene.getDocumentRoot()))) {
            agentService.restoreSession(session, scene.getDocumentRoot());
        }
    } catch (err) {
        console.warn(`[AI] Could not restore the editor content of ${file.name}:`, err);
    }
}
